<div class="order-entry__panel-form-notifications__container">
  <!-- fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="var(--ds-cont-spacing-common-gap-xs)" -->

  <div class="order-entry__panel-form-notifications__display__container">
    <!-- Order Basic - Order Entry -->
    <ng-container
      *ngIf="data.notification_config === OENDisplayState.SHOW_ORDER_ENTRY && operationMode !== 3 && operationMode !== 4 && entryType !== 3 && entryType !== 4"
    >
      <div class="order-entry__panel-form-notifications__order-basic__container">
        <hr class="order-entry__panel-form-notifications__more__hr" />
      </div>
      <div class="order-entry__panel-form-notifications__order-basic__container">
        <button
          pButton
          type="button"
          (click)="addOco()"
          class="bfx-button-secondary-moderate order-entry__panel-form-notifications__add_strategy_button order-entry__panel-form-notifications__oco_button"
          [label]="data.button_labels.oco"
          [disabled]="data.button_locks.oco"
        ></button>
        <button
          pButton
          type="button"
          (click)="addIfDone()"
          class="bfx-button-secondary-moderate order-entry__panel-form-notifications__add_strategy_button order-entry__panel-form-notifications__ifdone_button"
          [label]="data.button_labels.ifDone"
          [disabled]="data.button_locks.ifDone"
        ></button>
        <button
          pButton
          type="button"
          (click)="addLoop()"
          class="bfx-button-secondary-moderate order-entry__panel-form-notifications__add_strategy_button order-entry__panel-form-notifications__loop_button"
          [label]="data.button_labels.loop"
          [disabled]="data.button_locks.loop"
        ></button>
        <button
          pButton
          type="button"
          (click)="addTimeout()"
          class="bfx-button-secondary-moderate order-entry__panel-form-notifications__add_strategy_button order-entry__panel-form-notifications__timeout_button"
          [label]="data.button_labels.timeout"
          [disabled]="data.button_locks.timeout"
        ></button>
      </div>
    </ng-container>
    <!-- Order Processing -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_PROCESSING">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-processing__container bfx-callout-neutral-sm bfx-callout-wrap"
      >
        <i class="icon_ion_info_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Order Success -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_SUCCESS">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-success__container bfx-callout-positive-sm bfx-callout-wrap"
      >
        <i class="icon_ion_check_circle_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Monitor Execution -->
    <div
      *ngIf="data.notification_config === OENDisplayState.SHOW_MONITOR_EXECUTION"
      [class]="visibilityClass"
    >
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <bfx-callout
        [calloutType]="data.monitor_execution.callout_type"
        [calloutSize]="data.monitor_execution.callout_size"
        [message]="data.monitor_execution.callout_message"
        (onCalloutHide)="hideCallout()"
        [showClear]="true"
      >
      </bfx-callout>
    </div>

    <!-- Order Rejected -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_REJECTED">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-rejected__container bfx-callout-negative-sm bfx-callout-wrap"
        [bfxTooltip]="data.tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__error-tooltip"
      >
        <i class="icon_ion_error_filled"></i> <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Order Approval  -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_APPROVAL_ALLOWED">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-approval-allowed__container bfx-callout-info-sm bfx-callout-wrap"
        [bfxTooltip]="data.tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__tooltip"
      >
        <i class="icon_ion_info_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Order Approval Internal -->
    <ng-container *ngIf="data.notification_config ===  OENDisplayState.SHOW_APPROVAL_INTERNAL">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-approval-internal__container bfx-callout-info-sm bfx-callout-wrap"
        [bfxTooltip]="data.tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__tooltip"
      >
        <i class="icon_ion_info_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Order Approval External -->
    <ng-container *ngIf="data.notification_config ===  OENDisplayState.SHOW_APPROVAL_EXTERNAL">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-approval-external__container bfx-callout-info-sm bfx-callout-wrap"
        [bfxTooltip]="data.tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__tooltip"
      >
        <i class="icon_ion_info_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Order Approval External Modify -->
    <ng-container
      *ngIf="data.notification_config ===  OENDisplayState.SHOW_APPROVAL_EXTERNAL_MODIFY"
    >
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-approval-external__container bfx-callout-info-sm bfx-callout-wrap"
        [bfxTooltip]="data.tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__tooltip"
      >
        <i class="icon_ion_info_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Modify Out Acceptance -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_MODIFY_OUT_ACCEPTANCE">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-acceptance-allowed__container bfx-callout-info-sm bfx-callout-wrap"
        [bfxTooltip]="data.tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__tooltip"
      >
        <i class="icon_ion_info_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Order Acceptance Allowed -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_ACCEPTANCE_ALLOWED">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-acceptance-allowed__container bfx-callout-info-sm bfx-callout-wrap"
        [bfxTooltip]="data.tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__tooltip"
      >
        <i class="icon_ion_info_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Order Acceptance Call -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_ACCEPTANCE_CALL">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-acceptance-allowed__container bfx-callout-info-sm bfx-callout-wrap"
        [bfxTooltip]="data.tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__tooltip"
      >
        <i class="icon_ion_info_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Order Acceptance External -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_ACCEPTANCE_EXTERNAL">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-acceptance-external__container bfx-callout-info-sm bfx-callout-wrap"
        [bfxTooltip]="data.tooltip"
        tooltipPosition="top"
        tooltipStyleClass="order-entry__panel-form-notifications__tooltip"
      >
        <i class="icon_ion_info_filled"></i>
        <span [innerHTML]="data.message"></span>
      </div>
    </ng-container>
    <!-- Order UNLOCKED -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_UNLOCKED">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-success__container bfx-callout-negative-sm bfx-callout-wrap"
      >
        {{data.message}}
      </div>
    </ng-container>
    <!-- Order Lost/Hidden -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_LOST_HIDDEN">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-rejected__container bfx-callout-negative-sm bfx-callout-wrap"
      >
        {{data.message}}
      </div>
    </ng-container>
    <!-- Order EXPIRY PENDING -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_EXPIRY_PENDING">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-expiry-pending__container bfx-callout-info-sm bfx-callout-wrap"
      >
        {{data.message}}
      </div>
    </ng-container>
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_NEGATIVE_MARKUP_WARN">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div
        class="order-entry__panel-form-notifications__order-negative-markup-warn__container bfx-callout-neutral-sm bfx-callout-wrap"
      >
        <i class="icon_ion_info_filled"></i>
        <span>{{data.message}}</span>
      </div>
    </ng-container>
    <!-- Show Zero BM AMount Warning -->
    <ng-container *ngIf="data.notification_config === OENDisplayState.SHOW_BM_ZERO_AMOUNT_WARN">
      <hr class="order-entry__panel-form-notifications__more__hr" />
      <div class="bfx-callout-info-sm bfx-callout-wrap">
        <i class="icon_ion_info_filled"></i>
        <span>{{data.message}}</span>
      </div>
    </ng-container>
  </div>
  <div class="order-entry__panel-form-notifications__display__container" *ngIf="data.warning.show">
    <div class="order-entry__panel-form-notifications__order-basic__container">
      <hr class="order-entry__panel-form-notifications__display__hr" />
    </div>
    <!-- WARNING -->
    <div
      class="order-entry__panel-form-notifications__permissions-warning__container bfx-callout-warning-sm bfx-callout-wrap"
    >
      <i class="icon_ion_warning_filled"></i>
      <span [innerHTML]="data.warning.message"></span>
    </div>
  </div>
</div>
